export default {
      id: "icon--chevron-down-new-usage",
      viewBox: "0 0 8 6",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-down-new-usage",
      toString: function () {
        return this.url;
      }
    }